module.exports = __webpack_public_path__ + "img/A58A0834.2a19bb53.jpg";